import { computed, inject, Injectable, Signal } from '@angular/core';
import { ENVIRONMENT } from '../settings/custom.tokens';
import { Environment, FeatureFlags } from '@iot-platform/models/common';
import { get } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  canNavigateFromConnectorToIot4bos: Signal<boolean> = computed(() => this.isFeatureEnabled(FeatureFlags.NavigateConnectorToIot4bos));
  canUploadToGoogleDrive: Signal<boolean> = computed(() => this.isFeatureEnabled(FeatureFlags.UploadToGoogleDrive));
  private readonly environment: Environment = inject(ENVIRONMENT);

  isFeatureEnabled(feature: FeatureFlags): boolean {
    return get(this.environment, ['featureFlags', feature]) === true;
  }
}
